import { useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { TooltipIcon } from "./icons/TooltipIcon";

const TOOLTIP_WIDTH = 316;

export default function Tooltip({ text, children, className = "", placement = "top" }) {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const anchorRef = useRef(null);

  const updateCoords = () => {
    if (!anchorRef.current) return;
    const rect = anchorRef.current.getBoundingClientRect();
    const vw = window.innerWidth;
    let left = rect.left;
    if (left + TOOLTIP_WIDTH > vw - 8) {
      left = Math.max(8, vw - TOOLTIP_WIDTH - 8);
    }
    const top = placement === "top" ? rect.top - 8 : rect.bottom + 8;
    setCoords({ top, left });
  };

  useLayoutEffect(() => {
    if (!visible) return;
    updateCoords();
    window.addEventListener("scroll", updateCoords, true);
    window.addEventListener("resize", updateCoords);
    return () => {
      window.removeEventListener("scroll", updateCoords, true);
      window.removeEventListener("resize", updateCoords);
    };
  }, [visible]);

  return (
    <span
      ref={anchorRef}
      className={`relative inline-flex items-center ${className}`}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children ?? (
        <span className="cursor-pointer inline-flex">
          <TooltipIcon />
        </span>
      )}
      {visible &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: coords.top,
              left: coords.left,
              width: TOOLTIP_WIDTH,
              zIndex: 9999,
              transform: placement === "top" ? "translateY(-100%)" : undefined,
            }}
            className="rounded-[12px] bg-white px-[16px] py-[12px] text-[12px] leading-[18px] text-[#636369] shadow-[0px_0px_10px_0px_#0000001A] border border-[#ECECED] !font-[400]"
          >
            {text}
          </div>,
          document.body,
        )}
    </span>
  );
}
